export default __webpack_public_path__ + "static/media/Boots of the Triumphant.56d65012.jpg";